// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"467":"06465d4e","880":"88ea104c"}[chunkId] + ".chunk.css";
};